import React from "react";
import { Link } from "react-router-dom";
import { Seo } from "@/components/Seo";
import { RealisationsGrid, useHomeContent } from "@/components/HomeSections";

export default function RealisationsPage() {
  const { data, s } = useHomeContent();
  if (!data) return null;
  return (
    <main className="wrap" style={{ paddingTop: 160, paddingBottom: 96 }} data-testid="realisations-page">
      <Seo
        title="Réalisations — publicité, télévision, création IA | SLIZ"
        description="Publicité, télévision, création IA : les films SLIZ sont en ligne, en entier. M6, CNC, Sunions, Yachts de Paris et créations génératives."
        path="/realisations/"
      />
      <p className="t-label" style={{ marginBottom: 20 }}>Réalisations</p>
      <h1 className="t-h1" style={{ margin: 0 }}>{s.realisationsSec?.titre || "Nos films."}</h1>
      <p className="t-chapo" style={{ marginTop: 22, maxWidth: 640 }}>
        {(s.realisationsSec?.chapeau || "").split("\n").map((line, i) => (
          <React.Fragment key={i}>{i > 0 && <br />}{line}</React.Fragment>
        ))}
      </p>
      <div style={{ marginTop: 56 }}>
        <RealisationsGrid projects={data.projects} filtres={s.realisationsSec?.filtres} />
      </div>
      <div style={{ borderTop: "1px solid var(--li)", marginTop: 80, paddingTop: 48, display: "flex", flexWrap: "wrap", gap: 32, justifyContent: "space-between", alignItems: "center" }}>
        <h2 className="t-h3" style={{ margin: 0, fontSize: 26 }}>Votre film mérite sa place ici.</h2>
        <Link to="/brief/" className="btn btn-primary" data-testid="realisations-cta-rdv">Prendre rendez-vous</Link>
      </div>
    </main>
  );
}
